import Document from '../document/Document.js';

/**
 * Document.
 */
export default class XMLDocument extends Document {}
